import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PageWpService } from 'src/app/services/page-wp.service';

@Component({
  selector: 'app-cookies-terms',
  templateUrl: './cookies-terms.component.html',
  styleUrls: ['./cookies-terms.component.scss']
})
export class CookiesTermsComponent implements OnInit {

  contentPage!: SafeHtml;

  constructor(private pageWpService: PageWpService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.pageWpService.getStaticBySlug('cookies').subscribe({
      next: (res) => {
        let data = res[0];
        this.contentPage = this.sanitizer.bypassSecurityTrustHtml(
          data.content.rendered
        );
      }
    })
  }

}
